import ControlBase from '../fabric/ControlBase';

class ShapeResizeControl extends ControlBase {
  minDimension = 8;
}

export default ShapeResizeControl;
